import CustomSelectListInput from '../CustomSelectListInput'
import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import YesNoSelect from '../YesNoSelect'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import { enterKeyHandler } from '../../../utils'
import FormSubmitButton from '../FormSubmitButton'
import FormHeading from '../FormHeading'
import TextInput from '../TextInput'

export default function DuplicatePlaintiffReportForm({ location }) {
  console.log('DuplicatePlaintiffReportForm rendered: ', location)

  let init = {
    settlementGroup: [],
    waveGroupType: [],
    groupNumber: [],
    ssn: '',
    referringFirm: '',
    hasReleaseFile: '',
    hasSettlementAmount: '',
    match: 'DOB',
  }

  const navigate = useNavigate()
  init = initialFormValues('DuplicatePlaintiffReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('DuplicatePlaintiffReportForm', navigate, inputs, 'duplicates.duplicates')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Duplicate Plaintiff Report' />
            <tbody>
              <tr>
                <td><b>Match</b></td>
                <td>
                  <Input
                    type="select"
                    name="match"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                    defaultValue={inputs.match}
                  >
                    <option value={'CHILD'}>Show Child Records</option>
                    <option value={'DOB'}>Last Name / First Name / DOB</option>
                    <option value={'SSN'}>SSN</option>
                  </Input>
                </td>
              </tr>
              <CustomSelectListInput label="Settlement Group" handleChange={handleInputChange} modelName="BosSci" entityName="settlement_group" name='settlementGroup' multiple={true} defaultValue={inputs.settlementGroup} />
              <CustomSelectListInput label="Group Number" handleChange={handleInputChange} modelName="BosSci" entityName="group_number" name='groupNumber' multiple={true} defaultValue={inputs.groupNumber} />
              <TextInput label='Referring Firm' name='referringFirm' handleInputChange={handleInputChange} defaultValue={inputs.referringFirm} />
              <tr>
                <td><b>Has Release File?</b></td>
                <td>
                  <YesNoSelect name='hasReleaseFile' handleChange={handleInputChange} defaultValue={inputs.hasReleaseFile} />
                </td>
              </tr>
              <tr>
                <td><b>Has Settlement Amount?</b></td>
                <td>
                  <YesNoSelect name='hasSettlementAmount' handleChange={handleInputChange} defaultValue={inputs.hasSettlementAmount} />
                </td>
              </tr>
              <TextInput label='SSN' name='ssn' handleInputChange={handleInputChange} defaultValue={inputs.ssn} />
              <CustomSelectListInput label="Wave/Group Type" modelName="BosSci" entityName="segment" name="waveGroupType" handleChange={handleInputChange} multiple={true} defaultValue={inputs.waveGroupType} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

